const ROOT = 'SN/LOCATION';
const SET = `${ROOT}/SET`;
const SET_HOSTNAME = `${ROOT}/SET_HOSTNAME`;
const SET_DATA_PATH_PREFIX = `${ROOT}/SET_DATA_PATH_PREFIX`;

export { SET, SET_HOSTNAME, SET_DATA_PATH_PREFIX };
